/**
 * Посилання для QR у автобусах. Перевизначте через .env (потрібен rebuild):
 * REACT_APP_BUS_QR_INSTAGRAM_URL
 * REACT_APP_BUS_QR_TIKTOK_URL
 * REACT_APP_BUS_QR_WHATSAPP_GROUP_URL (invite link chat.whatsapp.com/...)
 */

const DEFAULT_INSTAGRAM =
  "https://www.instagram.com/sv_city_trans?igsh=enNvMnhieXplcDRn&utm_source=qr";

const DEFAULT_WHATSAPP_GROUP =
  "https://chat.whatsapp.com/GZ6COp5s13aCIzLTJZwjcC";

const DEFAULT_TIKTOK =
  "https://www.tiktok.com/@sv_city_trans?is_from_webapp=1&sender_device=pc";

export const BUS_QR_LINKS = {
  instagram: process.env.REACT_APP_BUS_QR_INSTAGRAM_URL || DEFAULT_INSTAGRAM,
  tiktok: process.env.REACT_APP_BUS_QR_TIKTOK_URL || DEFAULT_TIKTOK,
  whatsappGroup:
    process.env.REACT_APP_BUS_QR_WHATSAPP_GROUP_URL || DEFAULT_WHATSAPP_GROUP,
};
